import PropTypes from 'prop-types';
import React from 'react';
import styles from './DetailsForm.less';
import moment from 'moment-timezone';
import _ from 'lodash';
import $ from 'jquery';
import Tooltip from 'wix-style-react/Tooltip';
import Spinner from '@wix/restaurants-components-css-modules/dist/web/Spinner/Spinner';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';
import I18nify from '@wix/restaurants-components-css-modules/dist/shared/I18nify';
import UpgradeStrip from '../../../../shared/components/UpgradeStrip/UpgradeStrip';
import FormNoSubmit from '../../../../shared/components/FormNoSubmit/FormNoSubmit';
import Input from '../../../../shared/components/Input/Input';
import Textarea from '../../../../shared/components/Textarea/Textarea';
import DatePicker from '../../../../shared/components/Dropdown/DatePicker/DatePicker';
import Select from '../../../../shared/components/Dropdown/Select/Select';
import PencilSvg from '../../../../shared/components/Svg/Pencil';
import PlusSvg from '../../../../shared/components/Svg/Plus';
import {isTab} from '../../../../shared/utils/A11yHelpers';
import {getDateErrors, getMaxDelay} from '../../../../shared/utils/ReservationHelpers';
import {MODAL_A11Y_IDS} from '../../../../shared/constants';
import {PolicyHelper} from "../../../../shared/utils/policyHelper";
import {Policy} from "../../../../shared/components/Policy/Policy";
import {Modal} from "wix-style-react";
import {connect} from 'react-redux';

import ClientRadioCheckbox
    from "@wix/restaurants-components-css-modules/dist/web/ClientRadioCheckbox/ClientRadioCheckbox";
import {bindActionCreators} from "redux";
import {actions as formActions} from "../../../../actions/FormActions";
import * as WixRestBI from "@wix/wixrest-bi";

import CustomFields from './CustomFields';

const DetailsForm = ContentConnector({prefix: 'form_'})(I18nify(class extends React.Component {
    static displayName = 'DetailsForm';

    static propTypes = {
        restaurant: PropTypes.object.isRequired,
        form: PropTypes.object.isRequired,
        errors: PropTypes.object,
        settings: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onUpdate: PropTypes.func.isRequired,
        isCustomDesign: PropTypes.bool,
        preview: PropTypes.bool,
        onPremiumClick: PropTypes.func,
        i18n: PropTypes.object,
        isClosing: PropTypes.bool,
        onButtonBlur: PropTypes.func,
        doneButtonRef: PropTypes.func,
        onMount: PropTypes.func.isRequired,
        compId: PropTypes.string,
        isSendingReservation: PropTypes.bool
    };

    static defaultProps = {
        errors: {},
        onButtonBlur: () => {},
        doneButtonRef: () => {},
        onMount: () => {}
    };

    constructor(props) {
        super(props);
        this.inputs = {};
        const policyBMSettings = PolicyHelper.getPolicyFromOrganization(this.props.restaurant)

        this.state = {
            initialError: true, mounted: false,
            showTooltip: false,
            isSubmitting: !!props.isSendingReservation,
            editDetails: false,
            errorFocus: false,
            editRequests: !!props.form.reservation.requests,
            policyCheckboxShown: policyBMSettings && !!policyBMSettings.policyCheckbox,
            policyCheckboxChecked: policyBMSettings && policyBMSettings.policyCheckbox && policyBMSettings.policyCheckbox.checkedByDefault !== 'REQUIRED'
        };
    }

    componentDidMount() {
        this.props.onMount();
        this.setState({mounted: true});
        if (this._hasDateError()) {
            this.setState({editDetails: true}, () => {
                this._showTooltip();
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {editDetails, initialError, isSubmitting} = this.state;
        const {isSendingReservation: nextIsSendingReservation, isClosing, errors: nextErrors} = nextProps;
        const {errors, isSendingReservation} = this.props;
        const newState = {};

        if (isClosing) {
            this.setState({showTooltip: false});
            return;
        }

        if (isSubmitting && nextErrors !== errors) {
            newState.errorFocus = true;
        }

        if (isSendingReservation && !nextIsSendingReservation) {
            newState.isSubmitting = false;
        }

        if (this._hasDateError()) {
            if (!initialError && !editDetails) {
                newState.editDetails = true;
                newState.showTooltip = true;
            }
        } else {
            newState.initialError = false;
        }

        if (!_.isEmpty(newState)) {
            this.setState(newState);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {editRequests, errorFocus} = this.state;

        if (editRequests && !prevState.editRequests) {
            this.focusTiming = setTimeout(() => $(this.textareaCont).find('textarea').focus(), 600);
        } else if (!editRequests) {
            clearTimeout(this.focusTiming);
        }

        if (errorFocus) {
            this._focusErrorInputIfNeeded();
        }
    }

    componentWillUnmount() {
        this.setState({showTooltip: false, mounted: false});
        clearTimeout(this.tooltipTimeout);
        clearTimeout(this.focusTiming);
    }

    render() {
        const {isCustomDesign, preview, content, session, sessionActions, policyError, showPolicyError, contextStyles, errors, i18n, restaurant, form} = this.props;
        const {reservation} = form;
        const policies = PolicyHelper.getPolicy({
            organization: restaurant,
            onTextClickPrivacy: sessionActions.showPolicy,
            onTextClickTerm: sessionActions.showTerms,
            biActions:this.props.biActions
        })
        const title = this._getTitle();
        const info = this._getInfoSection();
        const requests = this._getRequestContent();
        const button = this._getButton();
        const upgradeStrip = this._getUpgradeStrip();
        let visibleState = this.state.mounted ? 'visible' : 'hidden';

        return (
            <div data-hook='details-form'>
                {policies && <Modal contentLabel={'meow'} zIndex={9999} isOpen={session.showPolicy}>
                    <Policy
                        i18n={i18n}
                        contextStyles={contextStyles}
                        isCustomDesign={isCustomDesign}
                        text={policies.privacyPolicy && policies.privacyPolicy.value}
                        title={i18n.get("openrest_checkoutconfirmationview_policies_popup_privacy" , "Privacy Policy")}
                        onClose={() => sessionActions.hidePolicy()}/>
                </Modal>}
                {policies && <Modal contentLabel={'meow'} zIndex={9999} isOpen={session.showTerms}>
                    <Policy
                        i18n={i18n}
                        contextStyles={contextStyles}
                        isCustomDesign={isCustomDesign}
                        text={policies.termsAndConditions && policies.termsAndConditions.value}
                        title={i18n.get( "openrest_checkoutconfirmationview_policies_popup_terms","Terms and Conditions")}
                        onClose={() => sessionActions.hideTerms()}/>
                </Modal>}
                <div
                    className={`${styles.content} ${isCustomDesign ? styles.custom : ''} ${preview ? styles.preview : ''}`}>
                    {upgradeStrip}
                    <div className={styles.innerWrapper} style={{visibility: visibleState}}>
                        <h3 className={styles.header} id={MODAL_A11Y_IDS.TITLE_ID} data-hook="dialog_title">{title}</h3>
                        {info}
                        <div className={styles.details}>
                            <div className={styles.label}>{content.get('contact_details')}</div>
                            <FormNoSubmit>
                                <div className={styles.detailSection}>
                                    {this._getInput(content.get('first_name'), 'firstName', true, false, 'fname', 'given-name', undefined, 'details_firstName')}
                                    {this._getInput(content.get('last_name'), 'lastName', false, false, 'lname', 'family-name', undefined, 'details_lastName')}
                                </div>
                                <div className={styles.detailSection}>
                                    {this._getInput(content.get('phone'), 'phone', false, true, 'phone', 'tel', 'tel', 'details_phone')}
                                    {this._getInput(content.get('email'), 'email', false, true, 'email', 'email', 'email', 'details_email')}
                                </div>
                                <CustomFields
                                    organization={restaurant}
                                    reservation={reservation}
                                    onChange={this._updateCustomFields}
                                    onFocus={this._onInputFocus}
                                    onSubmit={this._onSubmit}
                                    errors={errors}
                                    i18n={i18n}
                                />
                            </FormNoSubmit>
                        </div>
                        {requests}
                        {this.renderPolicy(policies)}
                        {policyError && showPolicyError && this.renderPolicyError()}
                        {button}
                    </div>
                </div>
            </div>
        );
    }

    renderPolicyError = () => {
        const {i18n}=this.props
        return <div data-hook={'policy-error'} className={styles.policyError}
                    style={{paddingTop: '10px', alignSelf: 'flex-start'}}>
            {i18n.get("openrest_checkoutconfirmationview_policies_error_unchecked" , "Please confirm you have read and agree to the terms.")}
        </div>
    }

    _getUpgradeStrip = () => {
        const {preview, onPremiumClick, content} = this.props;
        return preview ? (
            <UpgradeStrip
                onPremium={onPremiumClick}
                tip={content.get('preview_header_helptip')}
                primaryButtonText={content.get('preview_header_upgrade_button')}
                text={content.get('preview_header_text')}/>
        ) : null;
    };

    _getInput = (
        placeholder,
        type,
        focus,
        showTooltip,
        name,
        autocomplete,
        inputType,
        dataHook,
    ) => {
        const {form} = this.props;
        const {reservation} = form;
        const onChange = this._getUpdateCallback(type);

        return (
            <Input placeholder={placeholder}
                   type={inputType}
                   ref={el => this.inputs[type] = el}
                   name={name}
                   autocomplete={autocomplete}
                   placeholderClass={styles.placeholder}
                   containerClass={styles.inputContainer}
                   focusClass={styles.focus}
                   inputClass={styles.input}
                   value={reservation[type]}
                   error={this._getError(type, placeholder)}
                   errorTooltip={showTooltip}
                   focus={!!focus}
                   dataHook={dataHook}
                   onEnter={this._onSubmit}
                   onFocus={this._onInputFocus}
                   onChange={onChange}/>
        );
    };

    _onInputFocus = () => {
        this.setState({showTooltip: false});
    };

    _getUpdateCallback = (type) => {
        let cb = null;

        switch (type) {
            case 'firstName':
                cb = this._updateFirstNameField;
                break;
            case 'lastName':
                cb = this._updateLastNameField;
                break;
            case 'phone':
                cb = this._updatePhoneField;
                break;
            case 'email':
                cb = this._updateEmailField;
                break;
        }

        return cb;
    };

    _updateFirstNameField = (value) => {
        this._updateField(value, 'firstName');
    };

    _updateLastNameField = (value) => {
        this._updateField(value, 'lastName');
    };

    _updatePhoneField = (value) => {
        this._updateField(value, 'phone');
    };

    _updateEmailField = (value) => {
        this._updateField(value, 'email');
    };

    _updateCustomFields = (index, value) =>{
        this._updateField(value, `customFields.${index}`);
    };

    _getError = (type, placeholder) => {
        const {errors, content} = this.props;
        let error = null;

        if (errors[type]) {
            switch (type) {
                case 'firstName':
                case 'lastName':
                    error = content.get('error_empty', {params: {fieldType: placeholder}});
                    break;
                case 'phone':
                case 'email':
                    error = content.get(`error_${type}`);
                    break;
            }
        }

        return error;
    };

    _getInfoSection = () => {
        const {content} = this.props;
        const {editDetails} = this.state;

        return (
            <div className={`${editDetails ? styles.edit : styles.info}`} data-hook="reservation_details">
                <div className={styles.label}>
                    <span id="restaurants-seating-detailsform-edit-info">{content.get('table_info')}</span>
                    {!editDetails ?
                        <span className={styles.clickable}
                              onClick={this._onEdit}
                              data-hook="edit"
                              tabIndex="0"
                              role="button"
                              aria-describedby="restaurants-modal-description"
                              aria-labelledby="restaurants-seating-detailsform-edit-info">{this._getEditIcon()}</span>
                        : null}
                </div>
                {editDetails ? this._getEditContent() : this._getInfoContent()}
            </div>
        );
    };

    _getEditContent = () => {
        const {errors, restaurant, content} = this.props;
        const {initialError, showTooltip} = this.state;
        const dateErrors = getDateErrors(restaurant, errors, content);

        const editContent = (
            <div ref={el => this.inputs['time'] = el} tabIndex="0"
                 aria-describedby="restaurants-seating-dropdowns-error">
                <div key="date" className={styles.editDate}>
                    {this._getDatePicker()}
                </div>
                <div key="rest" className={styles.editRest}>
                    {this._getTimeField()}
                    {this._getPartyField()}
                </div>
            </div>
        );

        return initialError ? editContent : (
            <Tooltip content={<div role="alert" style={{wordWrap: 'normal'}}
                                   id="restaurants-seating-dropdowns-error">{dateErrors}</div>}
                     placement="left"
                     alignment="center"
                     theme="error"
                     showDelay={200}
                     hideDelay={0}
                     showTrigger="custom"
                     hideTrigger="custom"
                     maxWidth={'250px'}
                     active={!!dateErrors && showTooltip}>{editContent}</Tooltip>
        );
    };

    _getInfoContent = () => {
        const {form, restaurant} = this.props;
        const {date} = form.reservation;

        return (
            <div className={styles.infoContent} id="restaurants-modal-description">
                <span>{moment.tz(date, restaurant.timezone).format('ll')},</span>
                <span>{this._getFieldLabel('time')},</span>
                <span>{this._getFieldLabel('party')}</span>
            </div>
        );
    };

    _getFieldLabel = (type) => {
        const {form} = this.props;
        const {options, reservation} = form;
        let label = this.props[type];

        for (let i = 0; i < options[type].length; i++) {
            if (_.isEqual(reservation[type], options[type][i].value)) {
                label = options[type][i].name;
                break;
            }
        }

        return label;
    };


    togglePolicyCheckbox = () => {
        const {formActions,biActions} = this.props
        formActions.setPolicyError({policyError: false})
        this.setState(state => ({policyCheckboxChecked: !state.policyCheckboxChecked}))
        biActions.liveSiteOloConfirmationPageConsent({
            appName:'reservations',
            clickType:'checkbox',
            consentDescription:this.state.policyCheckboxChecked?'unchecking':'checking'
        })
    }
    renderPolicy = (polices) => {
        if (!polices) {
            return null
        }
        const {contextStyles, settings} = this.props
        const policyHelper = new PolicyHelper({isCustomDesign: settings.isCustomDesign, contextStyles})
        const text = policyHelper.getPoliciesText(polices)
        return <div data-hook='policy-checkbox' className={styles.divider} style={{
            display: 'flex', borderTop: ' solid 1px', alignSelf: 'flex-start'
            , paddingTop: '18px', width: '100%'
        }}>
            {this.state.policyCheckboxShown ?
                <div tabIndex={0} className={styles.openrest_ClientRadioCheckbox_wrapper_parentAddon}
                     style={{width: "100%"}} data-hook={`policy-checkbox-${this.state.policyCheckboxChecked}`}
                     onKeyPress={(event) => {
                         if (event.key === 'Enter' || event.which === 32) {
                             this.togglePolicyCheckbox()
                         }
                     }}
                     onClick={this.togglePolicyCheckbox}>
                    <ClientRadioCheckbox
                        type='checkbox'
                        backgroundColor={contextStyles.colors['color-1']}
                        borderColor={contextStyles.colors['color-8']}
                        activeColor={contextStyles.colors['color-8']}
                        checked={this.state.policyCheckboxChecked}
                    />{text}
                </div> :
                <div style={{width: "100%"}}>{text}</div>
            }

        </div>
    }

    _getRequestContent = () => {
        const {editRequests} = this.state;
        const {form, content} = this.props;
        const type = 'requests';

        return (
            <div className={`${styles.request} ${editRequests ? styles.show : ''}`}>
                <span key="toggle" role="button" className={`${styles.requestToggle} ${styles.clickable}`}
                      onClick={this._openRequestField} tabIndex={editRequests ? -1 : 0} onFocus={this._openRequestField}
                      data-hook="special_request">
                    <span className={`${styles.requestPlus} ${styles.svg}`}><PlusSvg pathClassName={styles.editStroke}/></span>
                    <span className={styles.requestAnchorText}>{content.get('special_requests')}</span>
                </span>
                <div className={styles.requestField} ref={el => this.textareaCont = el}>
                    <Textarea placeholder={content.get('request_disclaimer')}
                              placeholderClass={styles.placeholder}
                              className={styles.input} label={content.get('special_requests')}
                              focusClass={styles.focus}
                              value={form.reservation.requests}
                              onChange={value => this._updateField(value, type)}
                              onBlur={this._closeRequestField}
                              data-hook="textBox"/>
                </div>
            </div>
        );
    };

    _openRequestField = () => {
        if (!this.state.editRequests) {
            this.setState({editRequests: true});
        }
    };

    _closeRequestField = () => {
        const {form} = this.props;

        if (this.state.editRequests && !form.reservation.requests) {
            this.setState({editRequests: false});
        }
    };

    _getDatePicker = () => {
        const {form, errors, restaurant, settings, content, i18n, compId} = this.props;
        const {reservation, options} = form;
        const {date: dateOptions} = options;
        const {reservations, timezone} = restaurant;
        const {isCustomDesign} = settings;
        const maxDate = moment.tz(restaurant.timezone).add(getMaxDelay(reservations), 'minutes');

        return (
            <DatePicker key="date"
                        id={`${compId}-date`}
                        className={styles.datepicker}
                        onChange={value => this._updateField(value, 'date')}
                        onClick={this._openErrorIfNeeded}
                        value={reservation.date}
                        placeholder={content.get('date')}
                        locale={i18n._i18n.locale}
                        dir={i18n._i18n.dir}
                        max={maxDate}
                        options={dateOptions}
                        error={!!errors.date}
                        timezone={timezone}
                        reservations={reservations}
                        isCustomDesign={isCustomDesign}/>
        );
    };

    _getTimeField = () => {
        return this._getSelectField('time');
    };

    _getPartyField = () => {
        return this._getSelectField('party');
    };

    _getSelectField = (type) => {
        const {form, errors, settings, content, i18n, compId} = this.props;
        const {reservation, options} = form;
        const {isCustomDesign} = settings;

        return (
            <Select id={`${compId}-${type}`}
                    key={type}
                    type={type}
                    className={styles.select}
                    placeholder={content.get(type)}
                    locale={i18n._i18n.locale}
                    dir={i18n._i18n.dir}
                    onClick={this._openErrorIfNeeded}
                    onChange={value => this._updateField(value, type)}
                    isCustomDesign={isCustomDesign}
                    value={reservation[type]}
                    options={options[type]}
                    error={!!errors[type]}/>
        );
    };

    _openErrorIfNeeded = () => {
        const {errors} = this.props;

        if (errors['date'] || errors['time']) {
            this.setState({showTooltip: true});
        }
    };

    _onEdit = () => {
        this.setState({editDetails: true});
    };

    _onSubmit = () => {
        const {isSubmitting} = this.state;
        const {isSendingReservation, onSubmit, formActions} = this.props;
        if (this.state.policyCheckboxShown && !this.state.policyCheckboxChecked) {
            formActions.setPolicyError({policyError: true})
        }

        if (!isSendingReservation && !isSubmitting) {
            this.setState({isSubmitting: true}, () => {
                this._openErrorIfNeeded();
                onSubmit();
            });
        }
    };

    _getEditIcon = () => {
        const {content} = this.props;
        return (
            <Tooltip content={<div style={{textAlign: 'center'}}>{content.get('edit_details')}</div>}>
                <div className={styles.svg}>
                    <span
                        className={styles.hiddenError}>{content.get('edit_details')} {content.get('table_info')}</span>
                    <PencilSvg pathClassName={styles.editStroke}/>
                </div>
            </Tooltip>
        );
    };

    _updateField = (value, type) => {
        const {onUpdate} = this.props;
        onUpdate({value, type});
    };

    _getButton = () => {
        const {isSubmitting} = this.state;
        const {doneButtonRef} = this.props;

        return (
            <button ref={doneButtonRef} className={`${styles.reserveBtn} ${isSubmitting ? styles.spinner : ''}`}
                    onClick={this._onSubmit} onKeyDown={this._onButtonKeyDown} data-hook="book">
                {isSubmitting ? <Spinner radius={24}/> : <span className={styles.btnTxt}>{this._getButtonText()}</span>}
            </button>
        );
    };

    _onButtonKeyDown = (e) => {
        const {onButtonBlur} = this.props;
        const {tab, shiftKey} = isTab(e);

        if (tab && !shiftKey) {
            onButtonBlur();
            e.preventDefault();
        }
    };

    _getButtonText = () => {
        const {settings, content} = this.props;
        const {customButton} = settings;
        return customButton || content.get('default_button');
    };

    _hasDateError = () => {
        const {errors} = this.props;
        return (errors.date && (errors.date === errors.time));
    };

    _getTitle = () => {
        const {settings, content} = this.props;
        const {customTitle, showTitle} = settings;
        return customTitle && showTitle ? customTitle : content.get('title');
    };

    _showTooltip = () => {
        this.tooltipTimeout = setTimeout(() => {
            this.setState({showTooltip: true, initialError: false});
        }, 1200);
    };

    _focusErrorInputIfNeeded = () => {
        const {errors} = this.props;
        const inputOrder = ['time', 'firstName', 'lastName', 'phone', 'email'];

        for (let i = 0; i < inputOrder.length; i++) {
            const type = inputOrder[i];
            if (errors[type] && this.inputs[type]) {
                this.inputs[type].focus();
                break;
            }
        }

        this.setState({errorFocus: false});
    };
}));

function mapStateToProps(state) {
    return {
        showPolicyError: state.seatingForm.errors.showPolicyError,
        policyError: state.seatingForm.errors.policyError,
        contextStyles: state.styles.styles,
        settings: state.seatingSettings
    };
}
function mapDispatchToProps(dispatch) {
    return {
        formActions: bindActionCreators(formActions, dispatch),
        biActions: bindActionCreators(WixRestBI.redux.actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailsForm);
